import React, { useState, useEffect } from 'react';
import { FiX, FiExternalLink, FiCode } from 'react-icons/fi';
import Button from './Button';
import styles from './WelcomePopup.module.css';

const WelcomePopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has seen the popup before
    const hasSeenPopup = localStorage.getItem('hasSeenWelcomePopup');
    
    if (!hasSeenPopup) {
      // Show popup after a small delay for better UX
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    // Save to localStorage so it never shows again
    localStorage.setItem('hasSeenWelcomePopup', 'true');
  };

  const handleVisitPortfolio = () => {
    window.open('https://mrpawan.netlify.app/', '_blank');
    handleDismiss();
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div className={styles.backdrop} onClick={handleDismiss}></div>

      {/* Popup */}
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={handleDismiss} aria-label="Close">
          <FiX />
        </button>

        <div className={styles.popupContent}>
          {/* Left Content */}
          <div className={styles.leftContent}>
            <div className={styles.header}>
              <div className={styles.logoSection}>
                <h2 className={styles.appName}>RailTracker</h2>
              </div>
              <p className={styles.description}>
                Your ultimate companion for real-time train tracking, PNR status checks, 
                and comprehensive railway information. Built with precision and passion 
                to make your journey smoother.
              </p>
            </div>

            <div className={styles.divider}></div>

            <div className={styles.developerSection}>
              <h3 className={styles.sectionTitle}>Built By</h3>
              
              <div className={styles.developerInfo}>
                <div className={styles.developerDetails}>
                  <h4 className={styles.developerName}>Pawan Kumar</h4>
                  
                  <div className={styles.badgeAndButton}>
                    <div className={styles.badge}>
                      <FiCode />
                      <span>Developer</span>
                    </div>

                    <Button
                      variant="primary"
                      size="md"
                      onClick={handleVisitPortfolio}
                      className={styles.portfolioButton}
                    >
                      Visit Portfolio
                      <FiExternalLink />
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.footer}>
              <p className={styles.footerText}>
                Made with ❤️ for seamless railway tracking experience
              </p>
            </div>
          </div>

          {/* Right Content - Developer Image */}
          <div className={styles.rightContent}>
            <div className={styles.imageWrapper}>
              <img
                src="https://mrpawan.netlify.app/_next/image?url=%2Fprofile.png&w=640&q=75"
                alt="Pawan Kumar - Developer"
                className={styles.developerImage}
                onError={(e) => {
                  // Fallback if image fails to load
                  e.currentTarget.src = 'https://mrpawan.netlify.app/_next/image?url=%2Fprofile.png&w=640&q=75';
                }}
              />
              <div className={styles.imageBorder}></div>
            </div>
          </div>
        </div>

        {/* Dismiss Button at Bottom */}
        <div className={styles.dismissSection}>
          <button className={styles.dismissButton} onClick={handleDismiss}>
            Don't show this again
          </button>
        </div>
      </div>
    </>
  );
};

export default WelcomePopup;